<div class="flux-left-panel"
  [ngClass]="{hideNav: toggleStatus && navLayout === 'horizontal' && deviceType === 'mobile'}"
  [attr.nav-layout]="navLayout" [ngStyle]="{'height.px': asidebarHeight}"
  [attr.navbar-type]="toggleStatus ? defaultNavbar : toggleNavbar " [attr.effect-type]="navbarEffect"
  [attr.navbar-theme]="navbarColorTheme" [attr.active-Nav-theme]="activeNavColorTheme" [attr.device-type]="deviceType">
  <div class="flux-wrapper">
    <nav class="flux-navbar">
      <ul class="menu-list">
        <li *ngFor="let ml of menuList;  let i = index;" routerLinkActive="active" class="menu-item"
          [ngClass]="{active: isActive(ml.name), 'hasMenu':ml.subMenu}" appMenudropdown>
          <a *ngIf="!(ml.subMenu)" [routerLink]="ml.url" (click)="onItemSelect(ml.name);" style="direction: rtl;">
            <span class="flux-micon"><i class="{{ml.icon}}"></i></span>
            <span class="flux-mtext">{{ml.name_en | translate}}</span>
            <span *ngIf="(ml.badge)" class="flux-badge {{ml.badgeBg}}">{{ml.badge}}</span>

          </a>


        </li>
      </ul>
    </nav>
  </div>
</div>
